import React, { Component } from "react";

import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import FormManager from "./FormManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DirectLinkSection from "../common/DirectLinkSection";
import FormHeader from "./FormHeader";
import Utility from "../../utility/Utility";

class FormDomain extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    if (!FormManager.isPageDataAvailable() && this.props.match.params.id) {
      FormManager.fetchPageDataById(this.props.match.params.id, () => {
        this.setState({});
      });
    }
  }
  render() {
    return (
      <div className="column parent-width  ">
        <FormHeader title={"Publish Form"} stepperIndex={2} />
        <div
          className="column p-xl bg-white border-radius-s parent-width border-box mt-xl align-self-center shadow-s align-items-center"
          style={{ maxWidth: 800, marginBottom: 100 }}
        >
          <div className="" style={{ fontSize: 50 }}>
            🎉
          </div>
          <DKLabel
            text="Congratulations! Form Published"
            className="fw-m mt-m fs-xl"
          />
          <DKLabel
            text="Your form has been created successfully"
            className="mt-s"
          />

          {/* /////////// */}

          <DirectLinkSection
            className="mt-xl"
            url={FormManager.getDirectLink()}
          />

          {/* /////////// */}
          {/* /////////// */}

          <div className="mt-xxl p-xl border-radius-s bg-gray1 column parent-width border-m">
            <DKLabel className="fw-b fs-m" text="Embed Code" />
            <DKLabel
              className="text-gray mt-xs"
              text="Add this form to your website to start getting submissions from your visitors.<br/>If you have added this form to your website already, updates will be applied automatically"
            />
            <div className=" text-align-left text-wrap bg-white border-m border-radius-s p-r mt-m parent-width border-box text-black ">
              {FormManager.getEmbeddedFormScript()}
            </div>
            <DKButton
              title="Copy code"
              icon={DKIcons.ic_copy}
              className="mt-s"
              onClick={() =>
                Utility.copyToClipBoard(FormManager.getEmbeddedFormScript())
              }
            />
          </div>

          {/* /////////// */}

          <DKLabel
            text="You can visit to form homepage / list page to see how it is performing."
            className="mt-xxl "
          />

          <DKButton
            title="Goto Form list"
            className="bg-app text-white mt-l"
            onClick={() => {
              RouteManager.navigateToPage(PAGE_ROUTES.JOB_FORMS);
            }}
          />
        </div>
      </div>
    );
  }
}

export default FormDomain;
